function slugifySportValue(value: string) {
	return value
		.trim()
		.normalize("NFKD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase()
		.replace(/&/g, " and ")
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.replace(/-{2,}/g, "-");
}

export function normalizeSportSlug(value: string) {
	const normalized = slugifySportValue(value);
	return normalized || null;
}

export function normalizeSportSlugs(values: string[]) {
	return [
		...new Set(
			values
				.map(normalizeSportSlug)
				.filter((value): value is string => Boolean(value)),
		),
	];
}

export function formatSportLabel(value: string) {
	const normalized = normalizeSportSlug(value);
	const resolvedValue = normalized ?? value.trim();

	if (!resolvedValue) {
		return "";
	}

	return resolvedValue
		.split("-")
		.filter(Boolean)
		.map((segment) =>
			segment.length <= 2
				? segment.toUpperCase()
				: segment.charAt(0).toUpperCase() + segment.slice(1),
		)
		.join(" ");
}
